exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".loading-overlay[data-v-6625cbab]{position:fixed;width:100%;height:100%;z-index:100}", "", {"version":3,"sources":["/builds/bis/app.callmeweb.eu/platform/src/components/Common/LoadingOverlay/style.sass"],"names":[],"mappings":"AACA,kCACE,eAAgB,AAChB,WAAY,AACZ,YAAa,AACb,WAAa,CACd","file":"style.sass","sourcesContent":["\n.loading-overlay[data-v-6625cbab] {\n  position: fixed;\n  width: 100%;\n  height: 100%;\n  z-index: 100;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":true,"sourceMap":true}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6625cbab","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js?{"indentedSyntax":true,"sourceMap":true}!./~/sass-resources-loader/lib/loader.js?{"resources":["./src/styles/defs/_colors.sass","./src/styles/defs/_fonts.sass","./src/styles/mixins/_mixins.sass"]}!./src/components/Common/LoadingOverlay/style.sass
// module id = 552
// module chunks = 3